import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    users:null,
    loading: false,
    error:null,
    user:null,
    appKey:null
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.FETCH_USERS_BEGIN:
            return updateObject(state, {loading:true, error:null});
        case actionTypes.FETCH_USERS_SUCCESS: 
            return updateObject(state, {loading:false, users:action.payload.users});
        case actionTypes.FETCH_USERS_FAILED: 
            return updateObject(state, {loading:false, error:action.payload.error, users:null});
        case actionTypes.FETCH_USER_BEGIN:
            return updateObject(state, {loading:true, error:null});
        case actionTypes.FETCH_USER_SUCCESS: 
            return updateObject(state, {loading:false, user:action.payload.user});
        case actionTypes.FETCH_USER_FAILED: 
            return updateObject(state, {loading:false, error:action.payload.error, user:null});
        case actionTypes.ADD_USER_BEGIN:
          return updateObject(state, { loading: true, error: null });
        case actionTypes.ADD_USER_SUCCESS:
          return {
            ...state,
            loading: false,
            users: [
              ...state.users.slice(0, 0),
              action.payload.user.result,
              ...state.users.slice(0)
            ]
          };
            
        case actionTypes.ADD_USER_FAILED:
          return updateObject(state, { loading: false, error: action.payload.error, user: null });
        case actionTypes.UPDT_USER_SUCCESS:
            return updateObject(state, {loading:false, user:action.payload.user});
        case actionTypes.UPDT_USER_FAILED: 
            return updateObject(state, {loading:false, error:action.payload.error, user:null});
        default: 
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/user.js